import { render, staticRenderFns } from "./new-vexels.vue?vue&type=template&id=67e2c28f&scoped=true"
import script from "./new-vexels.vue?vue&type=script&lang=js"
export * from "./new-vexels.vue?vue&type=script&lang=js"
import style0 from "./new-vexels.vue?vue&type=style&index=0&id=67e2c28f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2c28f",
  null
  
)

export default component.exports